"use client";

import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

export function SkipLink({ className }: { className?: string }) {
  const { t } = useTranslation("admin");

  return (
    <a
      href="#main-content"
      className={cn(
        "sr-only focus:not-sr-only focus:absolute focus:start-4 focus:top-4 focus:z-50",
        "focus:rounded-md focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-medium",
        "focus:shadow-md focus:ring-2 focus:ring-primary focus:outline-none",
        className,
      )}
    >
      {t("a11y.skipToMain")}
    </a>
  );
}
